import searchQuery from '../search-query.js'
class App {
	constructor () {
		searchQuery()
		this.header()
		this.menuTop()
		this.scrollTop()
	}
	header () {
		try {
			let headerMenuIcons = document.querySelectorAll('.header-menu-icon')
			let menuBar = document.querySelector('.menu-bar')
			let body = document.querySelector('body')
			let isShowSideBar = false

			Array.from(headerMenuIcons).forEach((elm) => {
				elm.addEventListener('click', () => {
						if (!isShowSideBar) {
							menuBar.classList.remove('-translate-x-full')
							body.classList.add('overflow-y-hidden')
							isShowSideBar = true
						} else {
							menuBar.classList.add('-translate-x-full')
							body.classList.remove('overflow-y-hidden')
							isShowSideBar = false
						}
				})
			});

		} catch (error) {
			console.log('App.header', { message: error.message })
		}
	}

	menuTop () {
		try {
			let menuTop = document.querySelector('.menu-top')
			let header = document.querySelector('.header')
			let listMenu = menuTop?.querySelector('.list-menu')
			let iconHome = menuTop?.querySelector('.icon-home')
			let listChild = menuTop?.querySelector('.list-child')

			let playerWrapper = document.querySelector('.player-wrapper')

			let oldScroll =0
			let isScrollDown = false
			let isShowChild = false


			listMenu?.addEventListener('scroll', (e) => {
				let isScrollListMenu = false
				if (e.target.scrollLeft > 0 && !isScrollListMenu) {
					isScrollListMenu = true
					iconHome.classList.add('border-r-[1px]', 'border-[#bdbdbd]')
				} else {
					isScrollListMenu = false
					iconHome.classList.remove('border-r-[1px]', 'border-[#bdbdbd]')
				}
			})

			window.addEventListener('scroll', (e) => {
				if (window.scrollY > 54) {
					if (!isShowChild) {
						listChild?.classList.remove('hidden')
						isShowChild = true
					}
				} else {
					if (isShowChild) {
						listChild?.classList.add('hidden')
						isShowChild = false
					}
				}

				if (oldScroll > window.scrollY) {
					if (isScrollDown) {
						header.classList.add('top-0')
					header.classList.remove('top-[-57px]')
					menuTop.classList.add('top-[57px]')
						menuTop.classList.remove('top-0')
						playerWrapper?.classList.add('top-[103px]')
						playerWrapper?.classList.remove('top-[46px]')
						isScrollDown = false
					}

				} else {
					if (!isScrollDown) {
						header.classList.remove('top-0')
					header.classList.add('top-[-57px]')
					menuTop.classList.remove('top-[57px]')
						menuTop.classList.add('top-0')
						playerWrapper?.classList.remove('top-[103px]')
					playerWrapper?.classList.add('top-[46px]')
						isScrollDown = true
					}

				}
				oldScroll = window.scrollY
			})
		} catch (error) {
			console.log(error);

		}
	}

	scrollTop () {
    try {
      let backToTop = document.querySelector('#back-to-top')
      let isShow = false
      window.addEventListener('scroll', (e) => {
          if (window.scrollY > 200 ) {
          if (!isShow) {
            backToTop.classList.remove('opacity-0')
            isShow = true
          }
          } else {
           if (isShow) {
            backToTop.classList.add('opacity-0')
            isShow = false
           }
          }

        })

        backToTop.addEventListener('click', function () {
        window.scrollTo({top: 0, behavior: 'smooth'});
        })
    } catch (error) {
      console.log('App.scrollTop', {message: error.message});

    }
  }
}

export default window.addEventListener('DOMContentLoaded', () => {
	new App()
})
